<template>
  <div class="main-content">
    <!-- 标题 -->
    <div class="title">{{ $t('document.title') }}</div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t('nav.home') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('document.title') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 搜索栏 -->
    <div class="handle-box">
      <el-row>
        <el-col :span="8">
          <el-input v-model="searchForm.documentName" :placeholder="$t('document.documentName')" clearable></el-input>
        </el-col>
        <el-col :span="8">
          <el-select v-model="searchForm.documentType" :placeholder="$t('document.documentType')" clearable>
            <el-option v-for="item in documentTypes" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-input v-model="searchForm.relatedName" :placeholder="$t('document.relatedName')" clearable></el-input>
        </el-col>
      </el-row>
      <el-button type="primary" @click="search">{{ $t('common.search') }}</el-button>
      <el-button @click="reset">{{ $t('common.reset') }}</el-button>
      <el-button type="success" @click="handleAdd">{{ $t('common.add') }}</el-button>
    </div>

    <!-- 表格 -->
    <div class="table">
      <el-table :data="dataList" border v-loading="dataListLoading" @selection-change="selectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" header-align="center" align="center" width="80" :label="$t('table.id')"></el-table-column>
        <el-table-column prop="documentName" header-align="center" align="center" :label="$t('document.documentName')"></el-table-column>
        <el-table-column prop="documentType" header-align="center" align="center" :label="$t('document.documentType')"></el-table-column>
        <el-table-column prop="relatedName" header-align="center" align="center" :label="$t('document.relatedName')"></el-table-column>
        <el-table-column prop="uploadUserName" header-align="center" align="center" :label="$t('document.uploadUser')"></el-table-column>
        <el-table-column header-align="center" align="center" :label="$t('document.file')">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="downloadFile(scope.row.fileUrl)" v-if="scope.row.fileUrl">{{ $t('common.download') }}</el-button>
            <span v-else>{{ $t('common.none') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fileSize" header-align="center" align="center" :label="$t('document.fileSize')">
          <template slot-scope="scope">
            {{ formatFileSize(scope.row.fileSize) }}
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" :label="$t('common.status')">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">{{ scope.row.status === 1 ? $t('common.active') : $t('common.inactive') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" header-align="center" align="center" width="160" :label="$t('table.createTime')"></el-table-column>
        <el-table-column header-align="center" align="center" width="200" :label="$t('table.actions')">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)">{{ $t('table.view') }}</el-button>
            <el-button type="text" size="small" @click="handleEdit(scope.row)">{{ $t('table.modify') }}</el-button>
            <el-button v-if="scope.row.status === 1" type="text" size="small" @click="handleDisable(scope.row.id)">{{ $t('table.disable') }}</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row.id)">{{ $t('table.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;"
      ></el-pagination>
    </div>

    <!-- 添加/修改弹窗 -->
    <el-dialog :title="!dataForm.id ? $t('common.add') : $t('common.modify')" :visible.sync="dialogFormVisible" width="50%" @closed="closeDialog">
      <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="120px">
        <el-form-item :label="$t('document.documentName')" prop="documentName">
          <el-input v-model="dataForm.documentName" :placeholder="$t('document.documentName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('document.documentType')" prop="documentType">
          <el-select v-model="dataForm.documentType" :placeholder="$t('document.documentType')" style="width: 100%">
            <el-option v-for="item in documentTypes" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('document.description')" prop="description">
          <el-input type="textarea" v-model="dataForm.description" :placeholder="$t('document.description')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('document.relatedName')" prop="relatedName">
          <el-input v-model="dataForm.relatedName" :placeholder="$t('document.relatedName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('document.relatedId')" prop="relatedId">
          <el-input v-model="dataForm.relatedId" :placeholder="$t('document.relatedId')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('document.file')" prop="fileUrl">
          <el-upload
            class="upload-demo"
            :action="($base.url.endsWith('/') ? $base.url : $base.url + '/') + 'file/upload'"
            name="file"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :on-exceed="handleExceed"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :limit="1">
            <el-button size="small" type="primary">{{ $t('common.clickUpload') }}</el-button>
            <div slot="tip" class="el-upload__tip">{{ $t('document.uploadTip') }}</div>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('common.status')" prop="status">
          <el-radio-group v-model="dataForm.status">
            <el-radio :label="1">{{ $t('common.active') }}</el-radio>
            <el-radio :label="0">{{ $t('common.inactive') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="dataFormSubmit()">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>

    <!-- 查看弹窗 -->
    <el-dialog :title="$t('document.documentDetail')" :visible.sync="dialogViewVisible" width="50%">
      <el-descriptions :column="1" border>
        <el-descriptions-item :label="$t('document.documentName')">{{ viewForm.documentName }}</el-descriptions-item>
        <el-descriptions-item :label="$t('document.documentType')">{{ viewForm.documentType }}</el-descriptions-item>
        <el-descriptions-item :label="$t('document.description')">{{ viewForm.description }}</el-descriptions-item>
        <el-descriptions-item :label="$t('document.relatedName')">{{ viewForm.relatedName }}</el-descriptions-item>
        <el-descriptions-item :label="$t('document.uploadUser')">{{ viewForm.uploadUserName }}</el-descriptions-item>
        <el-descriptions-item :label="$t('document.file')">
          <el-button type="text" @click="downloadFile(viewForm.fileUrl)" v-if="viewForm.fileUrl">{{ $t('common.clickDownload') }}</el-button>
          <span v-else>{{ $t('common.none') }}</span>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('document.fileSize')">{{ formatFileSize(viewForm.fileSize) }}</el-descriptions-item>
        <el-descriptions-item :label="$t('common.status')">
          <el-tag :type="viewForm.status === 1 ? 'success' : 'danger'">{{ viewForm.status === 1 ? $t('common.active') : $t('common.inactive') }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('table.createTime')">{{ viewForm.createTime }}</el-descriptions-item>
        <el-descriptions-item :label="$t('table.updateTime')">{{ viewForm.updateTime }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogViewVisible = false">{{ $t('common.close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        documentName: '',
        documentType: '',
        relatedName: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      dialogFormVisible: false,
      dialogViewVisible: false,
      fileList: [],
      documentTypes: [], // 文档类型列表
      dataForm: {
        id: 0,
        documentName: '',
        documentType: '',
        description: '',
        fileUrl: '',
        fileSize: null,
        uploadUserId: '',
        uploadUserName: '',
        uploadUserRole: '',
        relatedId: '',
        relatedName: '',
        status: 1
      },
      viewForm: {
        id: 0,
        documentName: '',
        documentType: '',
        description: '',
        fileUrl: '',
        fileSize: null,
        uploadUserId: '',
        uploadUserName: '',
        uploadUserRole: '',
        relatedId: '',
        relatedName: '',
        status: 1,
        createTime: '',
        updateTime: ''
      },
      dataFormRules: {
        documentName: [
          { required: true, message: this.$t('document.documentNameRequired'), trigger: 'blur' }
        ],
        documentType: [
          { required: true, message: this.$t('document.documentTypeRequired'), trigger: 'change' }
        ],
        relatedId: [
          { required: true, message: this.$t('document.relatedIdRequired'), trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getDataList()
    this.getDocumentTypes()
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
        documentName: this.searchForm.documentName,
        documentType: this.searchForm.documentType,
        relatedName: this.searchForm.relatedName
      }
      this.$http({
        url: '/document/page',
        method: 'get',
        params: params
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.dataList = data.data.list || []
          this.totalPage = data.data.total || 0
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      }).catch(() => {
        this.dataList = []
        this.totalPage = 0
        this.dataListLoading = false
      })
    },
    // 获取文档类型列表
    getDocumentTypes() {
      this.$http({
        url: '/document/types',
        method: 'get'
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.documentTypes = data.data || []
        }
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 搜索
    search() {
      this.pageIndex = 1
      this.getDataList()
    },
    // 重置
    reset() {
      this.searchForm = {
        documentName: '',
        documentType: '',
        relatedName: ''
      }
      this.getDataList()
    },
    // 新增
    handleAdd() {
      this.dialogFormVisible = true
      this.fileList = []
      this.dataForm = {
        id: 0,
        documentName: '',
        documentType: '',
        description: '',
        fileUrl: '',
        fileSize: null,
        uploadUserId: '', // 将在保存时从登录信息中获取
        uploadUserName: '', // 将在保存时从登录信息中获取
        uploadUserRole: '', // 将在保存时从登录信息中获取
        relatedId: '',
        relatedName: '',
        status: 1
      }
      
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
      })
    },
    // 修改
    handleEdit(row) {
      this.dialogFormVisible = true
      this.fileList = row.fileUrl ? [{name: row.documentName, url: row.fileUrl}] : []
      
      this.dataForm = {
        id: row.id,
        documentName: row.documentName,
        documentType: row.documentType,
        description: row.description,
        fileUrl: row.fileUrl,
        fileSize: row.fileSize,
        uploadUserId: row.uploadUserId,
        uploadUserName: row.uploadUserName,
        uploadUserRole: row.uploadUserRole,
        relatedId: row.relatedId,
        relatedName: row.relatedName,
        status: row.status
      }
      
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
      })
    },
    // 查看
    handleView(row) {
      this.viewForm = Object.assign({}, row)
      this.dialogViewVisible = true
    },
    // 禁用
    handleDisable(id) {
      this.$confirm(this.$t('document.disableConfirm'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        this.$http({
          url: `/document/disable`,
          method: 'post',
          params: {id: id}
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: this.$t('common.operationSuccess'),
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg || this.$t('common.operationFailed'))
          }
        })
      }).catch(() => {})
    },
    // 删除
    handleDelete(id) {
      this.$confirm(this.$t('document.deleteConfirm'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/document/delete',
          method: 'post',
          data: [id]
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: this.$t('common.operationSuccess'),
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg || this.$t('common.operationFailed'))
          }
        })
      }).catch(() => {})
    },
    // 关闭弹窗
    closeDialog() {
      this.fileList = []
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].resetFields()
      }
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          // 获取当前登录用户信息
          const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
          
          // 设置上传人信息
          if (!this.dataForm.id) { // 新增时才更新上传人信息
            this.dataForm.uploadUserId = userInfo.id
            this.dataForm.uploadUserName = userInfo.username
            this.dataForm.uploadUserRole = 'admin' // 管理员角色
          }
          
          this.$http({
            url: `/document/${!this.dataForm.id ? 'save' : 'update'}`,
            method: 'post',
            data: this.dataForm
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: this.$t('common.operationSuccess'),
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.dialogFormVisible = false
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg || this.$t('common.operationFailed'))
            }
          })
        }
      })
    },
    // 上传文件前的验证
    beforeUpload(file) {
      const isValidType = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
        'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
        'image/jpeg', 'image/png'].includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isValidType) {
        this.$message.error(this.$t('document.uploadFileTypeError'))
      }
      if (!isLt10M) {
        this.$message.error(this.$t('document.uploadFileSizeError'))
      }
      return isValidType && isLt10M
    },
    // 上传成功回调
    uploadSuccess(res, file) {
      console.log(this.$t('document.uploadSuccessCallback'), res)
      
      // 处理XML格式的响应
      let code, fileUrl;
      
      if (typeof res === 'string' || res instanceof String || (res && res.indexOf && res.indexOf('<R>') !== -1)) {
        // XML响应处理
        const xmlString = res.toString();
        const codeMatch = xmlString.match(/<code>(.*?)<\/code>/);
        const fileMatch = xmlString.match(/<file>(.*?)<\/file>/);
        
        code = codeMatch && codeMatch[1] ? parseInt(codeMatch[1]) : null;
        fileUrl = fileMatch && fileMatch[1] ? fileMatch[1] : null;
        
        console.log(this.$t('document.parseXmlResponse'), { code, fileUrl });
      } else {
        // JSON响应处理
        code = res.code;
        fileUrl = res.file;
      }
      
      if (code === 0 && fileUrl) {
        this.dataForm.fileUrl = fileUrl;
        this.dataForm.fileSize = file.size / 1024; // 转换为KB
        
        // 如果文档名称为空，使用文件名作为文档名称
        if (!this.dataForm.documentName) {
          const originalName = file.name.substring(0, file.name.lastIndexOf('.'));
          this.dataForm.documentName = originalName;
        }
        
        this.$message.success(this.$t('document.uploadSuccess'));
      } else {
        this.$message.error((res.msg || this.$t('document.uploadFailed')) + (fileUrl ? '' : this.$t('document.noFileUrl')));
      }
    },
    // 上传出错
    uploadError(err, file, fileList) {
      console.error(this.$t('document.uploadErrorDetail'), err)
      this.$message.error(this.$t('document.uploadFileError') + (err.message || JSON.stringify(err)))
    },
    // 超出文件上传数量限制
    handleExceed() {
      this.$message.warning(this.$t('document.uploadFileLimit'))
    },
    // 下载文件
    downloadFile(fileUrl) {
      if (!fileUrl) {
        this.$message.warning(this.$t('document.fileNotExist'))
        return
      }
      
      // window.open(`${$base.url.endsWith('/') ? $base.url : $base.url + '/'}file/download?fileName=${fileUrl}`, '_blank')
     window.open(`${this.$base.url.endsWith('/') ? this.$base.url : this.$base.url + '/'}file/download?fileName=${fileUrl}`, '_blank')

   },
    // 格式化文件大小
    formatFileSize(sizeKB) {
      if (!sizeKB) return this.$t('document.fileSizeNone')
      
      if (sizeKB < 1024) {
        return sizeKB.toFixed(2) + this.$t('document.fileSizeKB')
      } else {
        return (sizeKB / 1024).toFixed(2) + this.$t('document.fileSizeMB')
      }
    }
  }
}
</script>

<style scoped>
.main-content {
  padding: 20px;
}
.handle-box {
  margin-bottom: 20px;
}
.el-row {
  margin-bottom: 10px;
}
.el-col {
  padding-right: 10px;
}
.upload-demo {
  margin-bottom: 10px;
}
</style> 